import Hero from "@/components/Hero";
import TrustedBy from "@/components/TrustedBy";
import MarqueeRibbon from "@/components/MarqueeRibbon";
import Process from "@/components/Process";
import Work from "@/components/Work";
import QuickCommerce from "@/components/QuickCommerce";
import SeedEditorial from "@/components/SeedEditorial";
import About from "@/components/About";
import Testimonials from "@/components/Testimonials";
import Contact from "@/components/Contact";
import Seo from "@/components/Seo";
import { SEO } from "@/lib/seo";

export default function Home() {
    return (
        <>
            <Seo {...SEO.home} />
            <Hero />
            <TrustedBy />
            <MarqueeRibbon />
            <Process />
            <Work />
            <QuickCommerce />
            <SeedEditorial />
            <About />
            <Testimonials />
            <Contact />
        </>
    );
}
